/*jslint white: true, plusplus: true, vars: true, undef: true, sloppy: true */
// 'use strict'

expocadfx.adbanner = function() {
    var elemById = expocadfx.element.elementById;
    var FxEvent = expocadfx.fxevent;

    var arAds = [];
    var adInterval = 1000;
    var firstAd = 0;
    var lastAd = 0;
    var pendingAd = 0;
    var usedWidth = 10;
    var timerId = null;
    var totalAds = 0;
    var displayedAds = 0;
    
    var ftr = elemById( "ftr");
    var footerText = elemById( "ftrTxt");
    var doc = document;
    var banner = doc.createElement( "div");
    banner.setAttribute( "class", "ftr_images");
    
    ftr.insertBefore( banner, footerText);
    
    function initAds() {
        totalAds = arAds.length;
        arAds[0].imgElement = createAdImg( 0);
        
        document.addEventListener( "visibilitychange", function() {
            if( timerId !== null) {
                if( document.hidden) {
                    clearTimeout( timerId);
                }
                else {
                    timerId = setTimeout( updateBanner, adInterval);
                }
            }
        });
    }
    
    function createAdImg( index) {
        var ad = doc.createElement( "img");
        ad.setAttribute( "data-index", index);
        ad.setAttribute( "class", "ftr_img");
        ad.style.visibility = "hidden";
        ad.src = arAds[index].source;
        ad.title = arAds[index].toolTip;
            // Attach new ad to body to get event and size;
        doc.body.appendChild( ad);
		
        ad.onload = imgLoaded;
        ad.addEventListener( "error", errorHandler);
        return ad;
    }
    
    function imgLoaded( evt) {
        var index = evt.target.getAttribute( "data-index");
        var ad = arAds[index].imgElement;
        arAds[index].width = ad.offsetWidth + 12;
        ad.style.visibility = "visible";
        
        if( usedWidth + ad.offsetWidth + 12 < ftr.clientWidth) {
            usedWidth += ad.offsetWidth + 12;
            banner.appendChild( ad);
            displayedAds += 1;
            lastAd = ad.getAttribute( "data-index");
            another();
        }
        else {
            doc.body.removeChild( ad);
            if( timerId !== null ) {
                window.clearTimeout( timerId);
            }
            timerId = setTimeout( updateBanner, adInterval);
        }
        ad.addEventListener( "click", clickHandler);
    }
    
    function errorHandler( evt) {
        var index = evt.target.getAttribute( "data-index");
		doc.body.removeChild( arAds[index].imgElement);
        arAds[index].failed = true;
        lastAd = evt.target.getAttribute( "data-index");
        totalAds -= 1;
        another();
    }

    function another() {
        var count = 0;
        if( totalAds <= displayedAds) {
            return;
        }
        pendingAd = lastAd;
        if( typeof( pendingAd) === "string") {
            pendingAd = parseInt(pendingAd, 10);
        }
        pendingAd = updateCount( pendingAd);
        
        while( arAds[pendingAd].failed ) {
            pendingAd = updateCount( pendingAd);
            count += 1;
            if( count > 20) {
                return;
            }
        }
        
        if( pendingAd === parseInt( lastAd, 10)) {
            return;
        }
        
        if( arAds[pendingAd].imgElement === null) {
            arAds[pendingAd].imgElement = createAdImg( pendingAd);
        }
        else {
            if( usedWidth + arAds[ pendingAd].width + 4 < ftr.clientWidth) {
                banner.appendChild( arAds[ pendingAd].imgElement);
                displayedAds += 1;
                usedWidth += arAds[ pendingAd].width;
                lastAd = arAds[ pendingAd].index;
                another();		  // is there room for more
            }
        }
    }
    
    function updateCount( pointer) {
        pointer += 1;
        if( pointer === arAds.length) {
            pointer = 0;
        }
        return pointer;
    }
    
    function updateBanner() {
        if( !document.hidden) {
            while( arAds[firstAd].failed) {
                firstAd = updateCount( firstAd);
            }
            var img = arAds[firstAd].imgElement;
            
            if( totalAds > displayedAds || usedWidth > ftr.clientWidth) {
                banner.removeChild( img);
                usedWidth -= arAds[firstAd].width;
                displayedAds -= 1;
                firstAd = updateCount( firstAd);
                while( arAds[firstAd].failed) {
                    firstAd = updateCount( firstAd);
                }
                another();
            }
        }
        timerId = setTimeout( updateBanner, adInterval);
    }
    
    function resize() {
        while( usedWidth > ftr.clientWidth) {
            banner.removeChild( arAds[firstAd].imgElement);
            usedWidth -= arAds[firstAd].width;
            displayedAds -= 1;
            firstAd = updateCount( firstAd);
            while( arAds[firstAd].failed) {
                firstAd = updateCount( firstAd);
            }
        }
        timerId = setTimeout( updateBanner, adInterval);
    }
    
    function clickHandler( evt) {
        var index = evt.target.getAttribute( "data-index");
        var ad = arAds[index];
        var obj = {
            "boothNumber" : ad.zoomTo,
            "imgSource" : ad.source,
            "name" : ad.name,
            "url" : ad.navTo
        };
        document.dispatchEvent( new FxEvent( "Ad_Click", obj));
    }
    
    return {
        arAds: arAds,
        initAds : initAds,
        resize : resize,
        setAdInterval : function( value) {
            adInterval = value * 1000;
        }
    };
};